import { destroy, post, put, get } from './helpers/fetch';
import join from 'url-join';
import { SLOW_REQUEST_THRESHOLD } from '../constants/urls';

export default class LicensedProductsDAO {
  accessToken: string;
  fastServerUrl: string;
  logging: Object;

  constructor(accessToken: string, fastServerUrl: string, logger: Object) {
    this.accessToken = accessToken;
    this.fastServerUrl = fastServerUrl;
    this.logging = { logger, loggingThreshold: SLOW_REQUEST_THRESHOLD };
  }

  fetchLicensedProducts(params) {
    return get({
      accessToken: this.accessToken,
      url: this.getUrl('licensedproducts'),
      params,
      headers: { 'Content-Type': 'application/json' },
      ...this.logging
    });
  }

  fetchLicensedProductSeats(params) {
    return get({
      accessToken: this.accessToken,
      url: this.getUrl('licensedproductseats'),
      params,
      headers: { 'Content-Type': 'application/json' },
      ...this.logging
    });
  }

  fetchRoles(params) {
    return get({
      accessToken: this.accessToken,
      url: this.getUrl('roles'),
      params,
      headers: { 'Content-Type': 'application/json' },
      ...this.logging
    });
  }

  fetchSeatActivations(params) {
    return get({
      accessToken: this.accessToken,
      url: this.getUrl('seatactivations'),
      params,
      headers: { 'Content-Type': 'application/json' },
      ...this.logging
    });
  }

  deleteSeatActivations(id) {
    return destroy({
      accessToken: this.accessToken,
      url: this.getUrl(join('seatactivations', id)),
      headers: { 'Content-Type': 'application/json' },
      ...this.logging
    });
  }

  getUrl(endpoint: string) {
    return join(this.fastServerUrl, endpoint);
  }
}